const questionCountTemplate = ({questionCountText}) => `<p>${questionCountText}</p>`;

export default questionCountTemplate;
